export default __webpack_public_path__ + "static/media/seo3.e0639870.png";